// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3xEG4","inputDescription":"styles_inputDescription__27PSZ"};